export default "__VITE_ASSET__BopPrZk4__"